<template>
    <section class="video-banner--wrapper">
        <div class="pattern-bg"></div>
        <img v-if="isMobile" class="video-background hidden--md" :src="videoImg"/>
        <video v-else autoplay muted loop id="video">
            <source src="/static/video/web_office_final.mp4" type="video/mp4"/>
            <source src="/static/video/web_office_final.ogg" type="video/ogg"/>
        </video>
        <div class="content-wrapper">
            <div class="content-container">
                <div class="heading-wrapper">
                    <div class="gradient-line"></div>
                    <span class="work-with-us">WHY WORK WITH US?</span>
                    <h1 class="text-uppercase heading">
                        BECAUSE WE MAKE <span class="underline--gradient__green">AMAZING GAMES</span><br/>
                        FOR <span class="underline--gradient__green">AWESOME PEOPLE</span>
                    </h1>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import videoImg from '../../static/img/incubator_videopreview_mobile.png'

    export default {
        name: "video-banner",
        data() {
            return {
                videoImg
            }
        },
        computed: {
            isMobile() {
                return window.screen.availWidth < 768
            }
        },

    }


</script>

<style scoped lang="scss" type="text/scss">
    @import "../assets/scss/main";

    .video-background {
        width: 100%;
    }

    .video-banner--wrapper {
        max-height: 870px;
        @media(max-width: $compact) {
            max-height: 500px;
            margin-bottom: -4px;
        }
        position: relative;
        overflow: hidden;
        background-size: cover;
    }

    .gradient-line {
        display: inline-block;
        width: 30px;
        height: 2px;
        margin-bottom: 4px;
        margin-right: 10px;
        background-image: -webkit-gradient(linear, right top, left top, from(rgba(110, 58, 203, 0.9)), to(rgba(0, 181, 242, 0.9)));
        background-image: linear-gradient(270deg, rgba(110, 58, 203, 0.9) 0%, rgba(0, 181, 242, 0.9) 100%);
        background-repeat: no-repeat;
        background-size: 100% 15px;
    }

    .content-wrapper {
        height: 100%;
        position: absolute;
        top: 0;
        width: 100%;
        .content-container {
            max-width: 1200px;
            margin: auto;
            position: relative;
            display: flex;
            height: 100%;
            align-items: center;
            justify-content: center;
            flex-direction: row;
            .heading-wrapper {
                z-index: 22;
                text-align: left;
                padding-bottom: 200px;
                @media (max-width: $tablet) {
                    padding-bottom: 20px;
                    padding-left: 20px;
                }
                @media (max-width: 360px) {
                    padding-bottom: 20px;
                }
            }
        }
    }

    #video {
        position: relative;
        margin-bottom: -3px;
        width: 100%;
    }

    .heading {
        letter-spacing: 2px;
        line-height: 78px;
        font-size: 55px;
        color: white;
        z-index: 10;

        @media (max-width: $mq-md-max) {
            font-size: 35px;
        }

        @media (max-width: $mq-xs-max) {
            font-size: 32px;
            letter-spacing: 1.16px;
            line-height: 34px;
        }
        @media (max-width: 360px) {
            font-size: 18px;
            letter-spacing: 1.16px;
            line-height: 23px;
        }
    }

    .underline--gradient__green {
        background-image: linear-gradient(270deg, rgba(110, 58, 203, 0.9) 0%, rgba(0, 181, 242, 0.9) 100%);
        background-repeat: no-repeat;
        background-size: 100% 15px;
    }

    .work-with-us {
        color: white;
        z-index: 10;

        @media (max-width: $mq-md-max) {
            font-size: 20px;
        }

        @media (max-width: $mq-xs-max) {
            font-size: 15px;
        }
    }

    .pattern-bg {
        background: radial-gradient(rgba(0, 0, 0, 0.58) 20%, transparent 20%), radial-gradient(rgba(0, 0, 0, 0.58) 20%, transparent 20%), rgba(0, 0, 0, 0.21);
        background-position: 0 0, 4px 4px;
        -webkit-background-origin: padding-box;
        background-origin: padding-box;
        -webkit-background-clip: border-box;
        background-clip: border-box;
        -webkit-background-size: 8px 8px;
        background-size: 8px 8px;
        position: absolute;
        opacity: 0.8;
        width: 100%;
        z-index: 10;
        bottom: 0;
        top: 0;
    }

</style>


// WEBPACK FOOTER //
// src/components/VideoBanner.vue